import instanceAxios from "./intanceAxios";


export const insumoService = {
    getInsumos: async (filters) => await instanceAxios.get('/assets/insumo/', { params: filters }),
    createInsumo: async (insumo) => await instanceAxios.post('/assets/insumo/', insumo),
    updateInsumo: async (insumo) => await instanceAxios.put(`/assets/insumo/`, insumo),
    deleteInsumo: async (id) => await instanceAxios.delete(`/assets/insumo/${id}`),
    getInsumoByHash: async (hash) => await instanceAxios.get(`/assets/insumo-hash/${hash}`),
    getTypeInsumos: async (params) => await instanceAxios.get('/assets/type-insumo/', { params }),
    createTypeInsumo: async (typeInsumo) => await instanceAxios.post('/assets/type-insumo/', typeInsumo),
    createInsumoMasive: async (insumos) => await instanceAxios.post('/assets/insumo-masive/', insumos),
    deleteInsumos: async (ids) => await instanceAxios.delete('/assets/insumo-delete/', { data: { ids } }),
    increaseStock: async (data) => await instanceAxios.post('/assets/insumo-stock/', data),
    decreaseStock: async (data) => await instanceAxios.put('/assets/insumo-stock/', data),
    // Insumo Task
    getInsumoTask: async (hash_code) => await instanceAxios.get(`/otask/insumo-task/`, { params: { hash_code } }),
}
